import { Fade } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import * as React from "react";
import { useSelector } from "react-redux";
import { commonActions } from "../../../../redux/reducers/CommonReducer";
import store from "../../../../redux/Store";
import EllipseButton from "../../Buttons/EllipseButton/EllipseButton";
import classes from "./MessageModal.module.css";

const MessageModal = () => {
  const messageModal = useSelector((state) => state.common.messageModal);
  const handleClose = () => {
    if (messageModal.cancelAction) {
      messageModal.cancelAction();
    }
    store.dispatch(commonActions.closeMessageModal());
  };

  return (
    <div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={messageModal.isShowModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={messageModal.isShowModal}>
          <Box className={classes.modalBox}>
            <div className={classes.modalContent}>
              <img src={messageModal.icon} />
              <span className={classes.title}>{messageModal.title}</span>
              <p className={classes.text}>{messageModal.text}</p>
              {messageModal?.modalBody}
              <div className={classes.modalButtons}>
                {messageModal.confirmText && (
                  <EllipseButton onClick={messageModal.confirmAction}>
                    {messageModal.confirmText}
                  </EllipseButton>
                )}
                {messageModal.cancelText && (
                  <EllipseButton isCancelButton={true} onClick={handleClose}>
                    {messageModal.cancelText}
                  </EllipseButton>
                )}
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default MessageModal;
